module.exports = __webpack_public_path__ + "img/sharp2.353d9961.png";